/* eslint-disable */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'utils/axios';

const name = 'invoice';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({
    name,
    initialState,
    extraReducers
});

function createInitialState() {
    return {
        error: null,
        loading: false,
        clientLoading: false,
        invoiceData: null,
        normalInvoiceData: null,
        listInvoiceData: null,
        invoiceAms: null,
        totalData: null
    };
}

function createExtraActions() {
    return {
        getInvoiceData: getInvoiceData(),
        createInvoice: createInvoice(),
        getInvoiceListData: getInvoiceListData(),
        getInvoiceAmsByDate: getInvoiceAmsByDate(),
        getInvoiceReferenceData: getInvoiceReferenceData(),
        sendInvoice: sendInvoice(),
        getInvoiceDataById: getInvoiceDataById(),
        deleteInvoice: deleteInvoice(),
        editInvoice: editInvoice(),
        editInvoicePaymentStatus: editInvoicePaymentStatus(),
        editInvoiceSentStatus: editInvoiceSentStatus()
    };
}

// create api
function getInvoiceData() {
    return createAsyncThunk(`${name}/getInvoiceData`, async (data) => {
        try {
            const response = await axios.post(`/invoice/invoiceEstimate`, data);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function getInvoiceListData() {
    return createAsyncThunk(
        `${name}/getInvoiceListData`,
        async ({ page, limit, search, startDate, endDate, userId, sentStatus, paymentStatus }) => {
            try {
                const response = await axios.get(`/invoice`, {
                    params: {
                        page,
                        limit,
                        search,
                        startDate,
                        endDate,
                        user_id: userId,
                        sentStatus,
                        paymentStatus
                    }
                });

                return response.data;
            } catch (err) {
                throw err;
            }
        }
    );
}

function getInvoiceDataById() {
    return createAsyncThunk(`${name}/getInvoiceDataById`, async (id) => {
        try {
            const response = await axios.get(`/invoice/${id}`);

            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function getInvoiceAmsByDate() {
    return createAsyncThunk(`${name}/getInvoiceAmsByDate`, async ({ startDate, endDate, search }) => {
        try {
            const response = await axios.get(`/invoice/pendingUsers`, {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    search
                }
            });

            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function getInvoiceReferenceData() {
    return createAsyncThunk(`${name}/getInvoiceReferenceData`, async (data) => {
        try {
            const response = await axios.post(`/invoice/referenceData`, data);

            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function createInvoice() {
    return createAsyncThunk(`${name}/createInvoice`, async (data) => {
        try {
            const response = await axios.post(`/invoice`, data);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function editInvoice() {
    return createAsyncThunk(`${name}/editInvoice`, async ({ invoice_id, data }) => {
        try {
            const response = await axios.patch(`/invoice/${invoice_id}`, data);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function editInvoicePaymentStatus() {
    return createAsyncThunk(`${name}/editInvoicePaymentStatus`, async ({ invoice_id, data }) => {
        try {
            const response = await axios.patch(`/invoice/paymentStatus/${invoice_id}`, data);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function editInvoiceSentStatus() {
   return createAsyncThunk(
       `${name}/editInvoiceSentStatus`,
       async ({ invoice_id, data }) => {
           try {
               // PATCH to your backend endpoint for sentStatus
               const response = await axios.patch(`/invoice/sentStatus/${invoice_id}`, data);
               return response.data;
           } catch (err) {
               throw err;
           }
       }
   );
}

function deleteInvoice() {
    return createAsyncThunk(`${name}/deleteInvoice`, async (data) => {
        try {
            const response = await axios.delete(`/invoice`, {
                data: data
            });
            return response;
        } catch (err) {
            throw err;
        }
    });
}

function sendInvoice() {
    return createAsyncThunk(`${name}/sendInvoice`, async ({ invoiceId, data }) => {
        try {
            const response = await axios.patch(`/invoice/sendInvoice/${invoiceId}`, data);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function createExtraReducers() {
    return {
        ...getInvoiceData(),
        ...getInvoiceListData(),
        ...getInvoiceDataById(),
        ...getInvoiceAMS()
    };

    function getInvoiceData() {
        const { pending, fulfilled, rejected } = extraActions.getInvoiceData;

        return {
            [pending]: (state) => {
                state.loading = true;
            },
            [fulfilled]: (state, action) => {
                state.loading = false;
                state.invoiceData = action.payload;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }
        };
    }

    function getInvoiceAMS() {
        const { pending, fulfilled, rejected } = extraActions.getInvoiceAmsByDate;

        return {
            [pending]: (state) => {
                state.clientLoading = true;
                state.invoiceAms = null;
            },
            [fulfilled]: (state, action) => {
                state.clientLoading = false;
                state.invoiceAms = action.payload;
            },
            [rejected]: (state, action) => {
                state.clientLoading = false;
                state.error = action.error.message;
            }
        };
    }

    function getInvoiceListData() {
        const { pending, fulfilled, rejected } = extraActions.getInvoiceListData;
        return {
            [pending]: (state) => {
                state.loading = true;
            },
            [fulfilled]: (state, action) => {
                state.loading = false;
                state.listInvoiceData = action.payload?.invoices;
                state.totalData = action.payload.totalInvoices;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }
        };
    }
    function getInvoiceDataById() {
        const { pending, fulfilled, rejected } = extraActions.getInvoiceDataById;
        return {
            [pending]: (state) => {
                state.loading = true;
            },
            [fulfilled]: (state, action) => {
                const { propertyInvoices, ...rest } = action.payload;
                const newArr = [...propertyInvoices];
                const propertyData = newArr.map((e) => {
                    const { createdAt, updatedAt, id, invoice_id, kpiIndicators, property, ...rest2 } = e;
                    return { ...rest2, propertyInfo: property };
                });
                const propertyData2 = newArr.map((e) => {
                    const { createdAt, updatedAt, id, invoice_id, property, ...rest2 } = e;
                    return { ...rest2, propertyInfo: property };
                });
                state.loading = false;
                state.invoiceData = { propertyInvoices: propertyData, finalInvoice: rest };
                state.normalInvoiceData = { propertyInvoices: propertyData2, finalInvoice: rest };
                state.invoiceAms = [rest?.user];
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }
        };
    }
}
export const invoiceActions = { ...slice.actions, ...extraActions };

export default slice.reducer;
